import React from 'react'
import '../../css/modal.scss'

type Props = {
  title: string,
  text: string,
  imageURL?: string,
  textIcon?: string,
  cssClass?: string
}

const ModalHeader = (props: Props) => {
  
  let extraClass = props.cssClass;
  extraClass = (typeof extraClass === 'undefined') ? '' : extraClass;

  return(
    <div className="thrive-modal-header">
      {props.imageURL && 
        <img alt='' src={props.imageURL} />
      }
      <h1>{props.title} <span className="iconWave">{props.textIcon}</span></h1>
      <p className={extraClass}>{props.text}</p>
    </div>
  )
}

export default ModalHeader